import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { getConvenienceTests, getConvenienceTestsDraftPdf } from '@repo/user-services'
import { convenienceTestsDataActions, convenienceTestsDraftPdfDownloadActions } from '../../slices'

export const convenienceTestsServiceConfig = defineSagaForService({
  [convenienceTestsDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getConvenienceTests,
    actionTypeResponse: convenienceTestsDataActions.getResponse.type,
    actionTypeRequest: convenienceTestsDataActions.getRequest.type,
  },
  [convenienceTestsDataActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getConvenienceTests,
    actionTypeResponse: convenienceTestsDataActions.refreshResponse.type,
    actionTypeRequest: convenienceTestsDataActions.refreshRequest.type,
  },
})

export const convenienceTestsDraftPdfDownloadConfig: Record<string, DownloadServiceConfiguration> =
  {
    [convenienceTestsDraftPdfDownloadActions.downloadRequest.type]: {
      apiClientDomain: 'user',
      service: getConvenienceTestsDraftPdf as DownloadServiceConfiguration['service'],
      actionTypeResponse: convenienceTestsDraftPdfDownloadActions.downloadResponse.type,
      actionTypeRequest: convenienceTestsDraftPdfDownloadActions.downloadRequest.type,
    },
  }
